import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../dishFullInfoState/dishFullInfoContext';
import EditBtn from './components/EditBtn';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './DishFullInfoControlPanel.module.scss';

const DishFullInfoControlPanel: React.FC = () => {
	const { changeDishFullInfoVisibleForm, dishFullInfoVisibleForm, dishForFullInfo } =
		useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container} data-test="DishFullInfoControlPanel">
			<div className={style.heading}>
				<Text translationKey={dishForFullInfo?.name || null} size="xxl" weight="bold" withTooltip={true} />
				<EditBtn />
			</div>
			<div className={style.bookMarks}>
				<PageBookmarkBtn
					onClick={() => changeDishFullInfoVisibleForm('mainForm')}
					isActive={dishFullInfoVisibleForm === 'mainForm'}
					btnName="mainInfoBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeDishFullInfoVisibleForm('additionallyForm')}
					isActive={dishFullInfoVisibleForm === 'additionallyForm'}
					btnName="additionallyBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeDishFullInfoVisibleForm('translationsForm')}
					isActive={dishFullInfoVisibleForm === 'translationsForm'}
					btnName="translationsBookmark"
				/>
			</div>
		</div>
	);
};

export default DishFullInfoControlPanel;
